/* eslint-disable no-underscore-dangle */
import robotoMediumFont from "./brand/fonts/binaries/RobotoMediumFont";

export const extractStyles = styles => {
  // if standard style-loader
  if (styles && styles.length > 0) {
    return styles[0][1];
  }

  // if isomorphic-style-loader
  if ('_getContent' in styles) {
    return styles._getContent().default.toString();
  }

  if ('_getCss' in styles) {
    return styles._getCss();
  }

  return {};
};

const spacing = [
  'spacing3xs',
  'spacing2xs',
  'spacingXs',
  'spacingSm',
  'spacingMd',
  'spacingLg',
  'spacingXl',
  'spacing2xl',
  'spacing3xl'
];

const layoutSpacing = [
  'layout2xs',
  'layoutXs',
  'layoutSm',
  'layoutMd',
  'layoutLg',
  'layoutXl',
  'layout2xl'
];

const horizontalSpacing = [
  'horizontalSpacingXs',
  'horizontalSpacingSm',
  'horizontalSpacingMd',
  'horizontalSpacingLg',
  'horizontalSpacingXl',
  'horizontalSpacing2xl',
  'horizontalSpacing3xl'
];

const horizontalLayout = [
  'horizontalLayoutXs',
  'horizontalLayoutSm',
  'horizontalLayoutMd',
  'horizontalLayoutLg',
  'horizontalLayoutXl',
  'horizontalLayout2xl',
  'horizontalLayout3xl'
];

const supportCarbonVars = [
  'brand-01',
  'brand-02',
  'brand-03',
  'ui-background',
  'ui-01',
  'ui-02',
  'ui-03',
  'overlay-01',
  'support-01',
  'support-02',
  'support-03',
  'support-04',
  'support-05',
  'support-06',
  'active-primary',
  'disable-primary',
  'focus-primary',
  'hover-primary',
  'hover-primary-text',
  'active-secondary',
  'hover-secondary',
  'hover-secondary-text',
  'active-tertiary',
  'hover-tertiary',
  'active-ui',
  'hover-ui',
  'selected-ui',
  'disabled',
  'highlight',
  'danger',
  'skeleton-01',
  'skeleton-02',
  'error',
  'warning',
  'success',
  'info',
  'note',
  'text-01',
  'text-02',
  'text-03',
  'text-04',
  'text-05',
  'text-06',
  'link-01',
  'spacing-01',
  'spacing-02',
  'spacing-03',
  'spacing-04',
  'spacing-05',
  'spacing-06',
  'spacing-07',
  'spacing-08',
  'spacing-09',
  'layout-01',
  'layout-02',
  'layout-03',
  'layout-04',
  'layout-05',
  'layout-06',
  'layout-07',
  'horizontal-spacing-01',
  'horizontal-spacing-02',
  'horizontal-spacing-03',
  'horizontal-spacing-04',
  'horizontal-spacing-05',
  'horizontal-spacing-06',
  'horizontal-spacing-07',
  'horizontal-layout-01',
  'horizontal-layout-02',
  'horizontal-layout-03',
  'horizontal-layout-04',
  'horizontal-layout-05',
  'horizontal-layout-06',
  'horizontal-layout-07',
  'grey-60',
  'grey-200',
  'grey-300',
  'grey-600',
  'grey-700',
  'grey-800',
  'grey-900',
  'black',
  'silver',
  'light-yellow',
  'error-border',
  'error-background',
  'category-card-background',
  'info-blue-background',
  'info-blue-border'
];

export const toKebabCase = k =>
  k
    .replace(/([a-z])([A-Z0-9])/g, '$1-$2')
    .replace(/([A-Z])([A-Z])(?=[a-z])/g, '$1-$2')
    .toLowerCase();

export const carbonCssVariables = m =>
  Object.entries(m)
    .map(([k, v]) => {
      if (k.startsWith('spacing')) {
        return [`spacing-0${spacing.indexOf(k) + 1}`, v];
      }
      if (k.startsWith('layout')) {
        return [`layout-0${layoutSpacing.indexOf(k) + 1}`, v];
      }
      if (k.startsWith('horizontalSpacing')) {
        return [`horizontal-spacing-0${horizontalSpacing.indexOf(k) + 1}`, v];
      }
      if (k.startsWith('horizontalLayout')) {
        return [`horizontal-layout-0${horizontalLayout.indexOf(k) + 1}`, v];
      }
      return [k, v];
    })
    .map(([k, v]) => {
      if (!supportCarbonVars.includes(toKebabCase(k))) {
        // eslint-disable-next-line no-console
        console.warn(`Invalid carbon variable: ${toKebabCase(k)} `);
      }
      return [k, v];
    })
    .map(([k, v]) => `--cds - ${toKebabCase(k)}: ${v} `)
    .join(';\n');

export const addThemeToPDF = async (doc) => {
  // This is specifically a font added for Greek characters
  // may need to add other fonts for other languages.

  // add the font to jsPDF
  doc.addFileToVFS("Roboto-Medium.ttf", robotoMediumFont);
  doc.addFont("Roboto-Medium.ttf", "Roboto-Medium", "normal");
  doc.setFont("Roboto-Medium");
}